import React from 'react';
import styled from 'styled-components';
import { MapContainer, TileLayer, CircleMarker, Circle, Tooltip } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import { standorte, zusatzgebiete } from '../data/standorte';

const MapWrap = styled.div`
  max-width: 900px;
  margin: 2rem auto 0;
  border-radius: 20px;
  overflow: hidden;
  border: 1px solid #e3eaf5;
  box-shadow: 0 12px 40px rgba(0, 52, 196, 0.14);

  .leaflet-container {
    height: 440px;
    width: 100%;
    font: inherit;
    background: #eaf0ff;
  }
  .leaflet-tooltip {
    font-weight: 700;
    color: var(--brand);
    border: 1px solid #d5e0f2;
    border-radius: 8px;
    box-shadow: 0 4px 14px rgba(0, 52, 196, 0.18);
  }
`;

// Zentrum auf den Kern des Einsatzgebiets (Bielefeld/Gütersloh) – entlegene Orte per Zoom/Pan erreichbar.
const CENTER: [number, number] = [52.0, 8.45];
// Ungefährer Einsatzradius über dem Kerngebiet (~30 km).
const RADIUS_M = 30000;

const EinsatzgebietMap: React.FC = () => (
  <MapWrap>
    <MapContainer center={CENTER} zoom={10} scrollWheelZoom={false}>
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>-Mitwirkende'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <Circle
        center={CENTER}
        radius={RADIUS_M}
        pathOptions={{
          color: '#0034C4',
          weight: 1.5,
          fillColor: '#234be6',
          fillOpacity: 0.08,
          dashArray: '6 6',
        }}
      />
      {standorte.map((ort) => (
        <CircleMarker
          key={ort.name}
          center={[ort.lat, ort.lng]}
          radius={9}
          pathOptions={{
            color: '#0034C4',
            weight: 2,
            fillColor: '#234be6',
            fillOpacity: 0.65,
          }}
          eventHandlers={{
            mouseover: (e) => e.target.setStyle({ radius: 12, fillOpacity: 0.9 }),
            mouseout: (e) => e.target.setStyle({ radius: 9, fillOpacity: 0.65 }),
          }}
        >
          <Tooltip direction="top" offset={[0, -6]}>{ort.name}</Tooltip>
        </CircleMarker>
      ))}
      {zusatzgebiete.map((ort) => (
        <CircleMarker
          key={ort.name}
          center={[ort.lat, ort.lng]}
          radius={8}
          pathOptions={{
            color: '#8593ad',
            weight: 2,
            fillColor: '#aab4c8',
            fillOpacity: 0.6,
          }}
          eventHandlers={{
            mouseover: (e) => e.target.setStyle({ radius: 11, fillOpacity: 0.85 }),
            mouseout: (e) => e.target.setStyle({ radius: 8, fillOpacity: 0.6 }),
          }}
        >
          <Tooltip direction="top" offset={[0, -6]}>{ort.name} (auf Anfrage)</Tooltip>
        </CircleMarker>
      ))}
    </MapContainer>
  </MapWrap>
);

export default EinsatzgebietMap;
